<template>
    <v-card>
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="ml-n3 mr-2">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <h2 class="font-weight-regular">
                Used Quantities Distribution
            </h2>
        </v-card-title>
        <v-divider class="ml-4 mr-5" />
        <v-card-text>
            <div class="table-container">
                <v-data-table
                    :headers="headers"
                    :items="filteredItems"
                    class="elevation-0 mt-5"
                    :mobile-breakpoint="0"
                    disable-pagination
                    hide-default-footer
                    sort-by="usedQuantity"
                    :sort-desc="true"
                    fixed-header
                >
                    <template v-slot:top>
                        <h2
                            class="px-4 py-2"
                            style="background-color: #eeeeee;"
                        >
                            BOM ITEMS USING {{ material }}
                        </h2>
                    </template>
                    <!--FILTERS-->
                    <template v-slot:[`header.bomCode`]="{ header }">
                        <v-text-field
                            class="py-2 mt-2"
                            :label="header.text"
                            v-model="filters.bomCode"
                            dense
                        />
                    </template>
                    <template v-slot:[`header.material`]="{ header }">
                        <v-text-field
                            class="py-2 mt-2"
                            :label="header.text"
                            v-model="filters.material"
                            dense
                        />
                    </template>
                    <template v-slot:[`header.status`]="{ header }">
                        <v-text-field
                            class="py-2 mt-2"
                            :label="header.text"
                            v-model="filters.status"
                            dense
                        />
                    </template>
                    <!--FOOTER-->
                    <template v-slot:[`body.append`]>
                        <tr
                            class="fixed-footer-row"
                            :style="{ 'background-color': '#eeeeee' }"
                        >
                            <td class="font-weight-bold"></td>
                            <td class="font-weight-bold"></td>
                            <td class="font-weight-bold text-right">TOTAL:</td>
                            <td class="font-weight-bold text-center">
                                {{ totalUsedQuantity }} /
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">{{
                                            originalFreeUse || 0
                                        }}</span>
                                    </template>
                                    <span>Reserved quantity</span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'QuantitiesUsedInBoms',
    props: {
        items: {
            type: Array,
            required: true,
            default: () => [],
        },
        originalFreeUse: {
            type: Number,
            required: true,
            default: 0,
        },
        material: {
            type: Object,
            required: true,
            default: null,
        },
    },
    data() {
        return {
            headers: [
                {
                    text: 'BOM',
                    value: 'bomCode',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'MATERIAL',
                    value: 'material',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'STATUS',
                    value: 'status',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'USED QUANTITY',
                    value: 'usedQuantity',
                    sortable: true,
                    align: 'center',
                },
            ],
            filters: {
                bomCode: '',
                material: '',
                status: '',
            },
        }
    },
    computed: {
        filteredItems() {
            // First filter out BOMs with usedQuantity = 0
            let filtered = this.items.filter(item => item.usedQuantity > 0)

            // Apply text filters with debounce
            if (this.filters.bomCode) {
                const bomCodeFilter = this.filters.bomCode.toLowerCase()
                filtered = filtered.filter(item =>
                    String(item.bomCode || '')
                        .toLowerCase()
                        .includes(bomCodeFilter)
                )
            }

            if (this.filters.material) {
                const materialFilter = this.filters.material.toLowerCase()
                filtered = filtered.filter(item =>
                    String(item.material || '')
                        .toLowerCase()
                        .includes(materialFilter)
                )
            }

            if (this.filters.status) {
                const statusFilter = this.filters.status.toLowerCase()
                filtered = filtered.filter(item =>
                    String(item.status || '')
                        .toLowerCase()
                        .includes(statusFilter)
                )
            }

            return filtered
        },
        totalUsedQuantity() {
            return this.filteredItems.reduce((total, item) => {
                return total + (item.usedQuantity || 0)
            }, 0)
        },
    },
    methods: {
        close() {
            this.$emit('closeDialog')
        },
    },
    mounted() {
        console.log(this.items)
    },
}
</script>

<style scoped>
.table-container {
    position: relative;
    height: 500px;
    overflow: hidden;
}

.table-container >>> .v-data-table {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.table-container >>> .v-data-table__wrapper {
    flex: 1;
    overflow-y: auto;
}

.table-container >>> .fixed-footer-row {
    position: sticky;
    bottom: 0;
    background-color: #eeeeee;
    z-index: 10;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.table-container >>> .fixed-footer-row td {
    background-color: #eeeeee !important;
}
</style>
